import { Box, Typography, Button, Grid, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Logo from "./logo_temp.png"; // Update with the path to your logo
import { useTranslation } from "react-i18next";
import {
  companyPhone,
  companyEmail,
  companyLegalAddress,
} from "../../config/globalVariables";
import { Router } from "@mui/icons-material";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        bgcolor: "primary.main",
        color: "primary.contrastText",
        py: {
          xs: 6, // mobile
          sm: 2, // tablets
          md: 10, // desktops
        },
        px: {
          xs: 2, // mobile
          sm: 2, // tablets
          md: 6, // desktops
        },
      }}
    >
      {/* Row 1: Logo */}
      {/* <Box sx={{ display: "flex", justifyContent: "flex-start", px: 3 }}>
                <img src={Logo} alt="Logo" style={{ height: "40px" }} />
            </Box> */}

      {/* Row 2: Three columns */}
      <Grid spacing="3" container sx={{ px: 3 }}>
        {/* First Column: Useful Links */}
        <Grid item xs={12} sm={4}>
          <Typography variant="h3" fontWeight="bold" mb={2}>
            {t("navigation.footer.useful_links")}
          </Typography>
          <Link
            component={RouterLink}
            to="/"
            sx={{ display: "block", mb: 1, color: "primary.contrastText" }}
          >
            {t("navigation.home")}
          </Link>
          <Link
            component={RouterLink}
            to="/buj"
            sx={{ color: "white", display: "block", mb: 1 }}
          >
            {t("navigation.faq")}
          </Link>
          <Link
            component={RouterLink}
            to="/parmums"
            sx={{ display: "block", mb: 1 }}
          >
            {t("navigation.about_us")}
          </Link>
          <Link
            component={RouterLink}
            to="/kontakti"
            sx={{ display: "block", mb: 1 }}
          >
            {t("navigation.contacts")}
          </Link>
          <Link
            component={RouterLink}
            to="/privatums"
            sx={{ display: "block", mb: 1 }}
          >
            {t("navigation.privacy_policy")}
          </Link>
          <Link
            component={RouterLink}
            to="/noteikumi"
            sx={{ display: "block", mb: 1 }}
          >
            {t("navigation.terms_of_use")}
          </Link>
        </Grid>

        {/* Second Column: Contacts */}
        <Grid item xs={12} sm={4}>
          <Typography variant="h3" fontWeight="bold" mb={2}>
            {t("navigation.footer.contacts")}
          </Typography>
          <Typography color="primary.contrastText" variant="body1" mb={1}>
            {t("navigation.footer.email")}: {companyEmail}
          </Typography>
          <Typography color="primary.contrastText" variant="body1" mb={1}>
            {t("navigation.footer.phone")}: {companyPhone}
          </Typography>
          <Typography color="primary.contrastText" variant="body1" mb={1}>
            {t("navigation.footer.address")}: {companyLegalAddress}
          </Typography>
        </Grid>

        {/* Third Column: Need Consultation */}
        <Grid item xs={12} sm={4}>
          <Typography variant="h3" fontWeight="bold" mb={2}>
            {t("navigation.footer.cta")}
          </Typography>
          <Typography variant="body1">
            {t("navigation.footer.cta_description")}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
